import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryTypes'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryTypesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryTypesStore",
			variables: false,
		})
	}
}

export async function load_InventoryTypes(params) {
  await initClient()

	const store = new InventoryTypesStore()

	await store.fetch(params)

	return {
		InventoryTypes: store,
	}
}
